import NavigationContainer from 'containers/customerAccounts/Navigations/index'
import React from 'react'


const NavigationPage = () => {

  return (
    <div><NavigationContainer/></div>
  )
}

export default NavigationPage